import { render, staticRenderFns } from "./DealerOptions.vue?vue&type=template&id=5b926270&scoped=true"
import script from "./DealerOptions.vue?vue&type=script&lang=ts"
export * from "./DealerOptions.vue?vue&type=script&lang=ts"
import style0 from "./DealerOptions.vue?vue&type=style&index=0&id=5b926270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_pqvrgeoyoc7vllsfv3djl2e3nu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b926270",
  null
  
)

export default component.exports